import { render } from "./spinner.vue?vue&type=template&id=5e45e4f2&scoped=true"
import script from "./spinner.vue?vue&type=script&lang=js"
export * from "./spinner.vue?vue&type=script&lang=js"

import "./spinner.vue?vue&type=style&index=0&id=5e45e4f2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5e45e4f2"

export default script